import { render, staticRenderFns } from "./professionIdea.vue?vue&type=template&id=52d96a38"
import script from "./professionIdea.vue?vue&type=script&lang=js"
export * from "./professionIdea.vue?vue&type=script&lang=js"
import style0 from "./professionIdea.vue?vue&type=style&index=0&id=52d96a38&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports